import type { AreaName, RoleName } from 'types';
import { ADMIN_GROUP, ROLE_AREAS, ROLES } from 'utils/constants';

const ROLE_VALUES: RoleName[] = Object.values(ROLES);

export const resolveRoles = (groups: string[]): RoleName[] =>
  groups.filter((group): group is RoleName => ROLE_VALUES.includes(group as RoleName));

export const isAdminGroup = (groups: string[]): boolean => groups.includes(ADMIN_GROUP);

export const getAreasForRoles = (roles: readonly RoleName[]): readonly AreaName[] =>
  roles.flatMap((role) => ROLE_AREAS[role]);

export const hasAreaAccess = (
  roles: readonly RoleName[],
  area: AreaName,
  isAdmin = false
): boolean => isAdmin || getAreasForRoles(roles).includes(area);
